import styled from "styled-components";

export const FeaturesSection = styled.section`
  background-color: ${({theme}) => theme.colors.basic};
  display: flex;
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    display: block;
  }
`;

export const FeaturesHeading = styled.div`
  flex: 1;
  position: relative;
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin: 0 auto;
    width: 450px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    width: 270px;
  }
`;

export const HeadingTitle = styled.h2`
  margin-top: 300px;
  width: 260px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin-top: 260px;
    width: 264px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin-top: 230px;
    width: 200px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    margin-top: 200px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    margin-top: 180px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin-top: 60px;
    width: 150px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    margin-top: 32px;
  }
`;

export const FeaturesItems = styled.div`
  display: flex;
  flex: 1;
  margin: 120px 0 100px 0;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin: 100px 0 90px -40px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin: 90px 0 80px -50px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    margin: 80px 0 70px -50px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    margin: 70px 0 60px -30px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin: 32px auto;
    width: 450px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    margin: 30px auto;
    width: 350px;
  }
`;

export const FeaturesColumn = styled.div`
  position: relative;
  &:first-child {
    margin-top: 40px;
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      margin-top: 32px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      margin-top: 28px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      margin-top: 24px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      margin-top: 20px;
    }
    &:after {
      border: 5px solid ${({theme}) => theme.colors.secondary};
      content: '';
      height: 50px;
      left: 50%;
      position: absolute;
      top: -60px;
      @media (max-width:${({theme}) => theme.breakpoint.hd}) {
        border: 4px solid ${({theme}) => theme.colors.secondary};
        height: 40px;
        top: -56px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.large}) {
        border: 3.5px solid ${({theme}) => theme.colors.secondary};
      }
      @media (max-width:${({theme}) => theme.breakpoint.default}) {
        border: 3px solid ${({theme}) => theme.colors.secondary};
        height: 32px;
        top: -44px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.medium}) {
        height: 28px;
        top: -40px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.tab}) {
        content: none;
      }
    }
  }
  &:last-child {
    &:before {
      border: 5px solid ${({theme}) => theme.colors.secondary};
      bottom: 209px;
      content: '';
      position: absolute;
      right: -60px;
      width: 40px;
      @media (max-width:${({theme}) => theme.breakpoint.hd}) {
        border: 4px solid ${({theme}) => theme.colors.secondary};
        bottom: 164px;
        right: -59px;
        width: 40px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.large}) {
        border: 3.5px solid ${({theme}) => theme.colors.secondary};
        bottom: 148px;
        right: -51px;
        width: 36px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.default}) {
        border: 3px solid ${({theme}) => theme.colors.secondary};
        bottom: 120px;
        right: -47px;
        width: 32px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.medium}) {
        bottom: 102px;
        right: -42px;
        width: 28px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.tab}) {
        content: none;
      }
    }
    &:after {
      border: 10px solid ${({theme}) => theme.colors.secondary};
      border-bottom: none;
      border-left: none;
      content: '';
      height: 84%;
      left: -50%;
      position: absolute;
      top: -30px;
      width: 168%;
      @media (max-width:${({theme}) => theme.breakpoint.hd}) {
        border-width: 8px;
        height: 85%;
      }
      @media (max-width:${({theme}) => theme.breakpoint.large}) {
        border-width: 7px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.default}) {
        border-width: 6px;
        top: -20px;
        width: 170%;
      }
      @media (max-width:${({theme}) => theme.breakpoint.tab}) {
        content: none;
      }
    }
  }
`;

export const FeaturesThumbnail = styled.div`
  border-radius: ${({theme}) => theme.radius.medium};
  margin: 36px 20px;
  padding: 36px;
  width: 280px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    border-radius: ${({theme}) => theme.radius.hdMedium};
    margin: 30px 16px;
    padding: 30px;
    width: 250px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin: 24px 14px;
    padding: 24px 28px;
    width: 220px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    border-radius: ${({theme}) => theme.radius.normal};
    margin: 20px 10px;
    padding: 20px 24px;
    width: 190px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    padding: 16px 20px;
    width: 160px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    border-radius: ${({theme}) => theme.radius.small};
    margin: 24px 20px;
    padding: 16px;
    width: 140px;
  }
  &.pos {
    background-color: rgba(148, 0, 153, 0.08);
  }
  &.inventory {
    background-color: rgba(0, 102, 203, 0.08);
  }
  &.cloud {
    background-color: rgba(255, 204, 0, 0.08);
  }
  &.qr {
    background-color: rgba(255, 119, 0, 0.08);
  }
  &.realtime {
    background-color: rgba(255,0, 127, 0.08);
  }
  &.online {
    background-color: rgba(	102, 203, 1, 0.08);
  }
  &.data {
    background-color: rgba(255, 0, 0, 0.08);
     p {
      @media (max-width:${({theme}) => theme.breakpoint.large}) {
        padding-right: 76px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.default}) {
        padding-right: 60px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.medium}) {
        padding-right: 54px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
        padding-right: 40px;
      }
     }
  }
  &.customer {
    background-color: rgba(17, 26, 81, 0.08);
  }
`;

export const StyledHeading = styled.h4`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 44px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin-bottom: 36px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin-bottom: 24px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    height: 40px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    height: 32px;
    margin-bottom: 20px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    height: 30px;
  }
`;

export const ImageIcon = styled.img`
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    transform: scale(.8);
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    transform: scale(.7);
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    transform: scale(.6);
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    transform: scale(.5);
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    position: relative;
    left: -12px;
  }
`;

export const SerialNumber = styled.span`
  color: ${({theme}) => theme.colors.default};
  font-family: "RubikLight";
  font-size: ${({theme}) => theme.fonts.subHeading};
  font-weight: 100;
  line-height: ${({theme}) => theme.lineHeight.subHeight};
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    font-size: ${({theme}) => theme.fonts.hdSubHeading};
    line-height: ${({theme}) => theme.lineHeight.secondaryHeight};
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    font-size: ${({theme}) => theme.fonts.lgSubHeading};
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    font-size: ${({theme}) => theme.fonts.subTitle};
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    font-size: ${({theme}) => theme.fonts.hdSubTitle};
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    font-size: ${({theme}) => theme.fonts.defaultSize};
  }
`;

export const StyledDetails = styled.p`
  padding-right: 60px;
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    padding-right: 50px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    padding-right: 40px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    padding-right: 32px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    padding-right: 24px;
  }
`;

export const ImgIllustration = styled.img`
  bottom: 90px;
  position: absolute;
  right: -90px;
  width: 120px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    bottom: 75px;
    right: -42px;
    width: 110px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    bottom: 64px;
    right: -24px;
    width: 96px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    bottom: 60px;
    right: -6px;
    width: 76px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    bottom: 52px;
    right: -15px;
    width: 64px;
  }
`;
